import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast, useToastContainer } from "react-toastify";
import axios from "axios";
import Cookies from 'js-cookie'
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { TableHead, TableRow, TableCell, Table, TableBody, TableSortLabel, TablePagination } from "@material-ui/core";




const CMS_HelpFaq = () => {

    const [faqs, setFaqs] = useState([]);
    const [idList, setIdList] = useState([]);
    const [search, setsearch] = useState("");
    const [searchflag, setsearchflag] = useState(false);
    const [loading, setLoading] = useState(false);
    const [color, setColor] = useState("#000000");

    const [sheet, setSheet] = useState(0);
    const [rowsPerSheet, setRowsPerSheet] = useState(10);

    const [getDelClass, setDelClass] = useState('hideModal');
    const [getMultiDelClass, setMultiDelClass] = useState('hideModal');
    const [delDisable, setDelDisable] = useState(false);
    const [delLoading, setdelLoading] = useState(false)
    const [delcolor, setdelColor] = useState("#FF7E06")
    const [getDelId, setDelId] = useState();

    window.onmousedown = (e) => {
        const modals = document.getElementsByClassName("modal viewModal");
        // console.log("clicked!!! => ", e.target);
        // console.log("modal => ", modals[0]);
        if (modals[0] === e.target) {
            if (getDelClass === 'viewModal')
                setDelClass('hideModal')
            else if (getMultiDelClass === 'viewModal')
                setMultiDelClass('hideModal')
        }
    }

    const handleChangePage = (event, newPage) => {
        setSheet(newPage);
        setIdList([]);
        const checkAllInput = document.getElementById("checkAllInput");
        if (checkAllInput.checked)
            checkAllInput.checked = false;
        const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
        for (let checkBox of checkBoxes1) {
            if (checkBox.checked)
                checkBox.checked = false;
        }
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerSheet(+event.target.value);
        setSheet(0);
        setIdList([]);
        const checkAllInput = document.getElementById("checkAllInput");
        if (checkAllInput.checked)
            checkAllInput.checked = false;
        const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
        for (let checkBox of checkBoxes1) {
            if (checkBox.checked)
                checkBox.checked = false;
        }
    };

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

    const callback = () => {
        setLoading(false);
        setdelLoading(false);
        setDelDisable(false);
    }

    useEffect(() => {
        setLoading(true);
        fetchFaqs();
    }, [])

    useEffect(() => {
        setIdList([]);
        const checkAllInput = document.getElementById("checkAllInput");
        if (checkAllInput.checked)
            checkAllInput.checked = false;
    }, [searchflag])

    useEffect(() => {
        if (idList.length !== 0)
            setDelDisable(false);
        else setDelDisable(true)
        const filteredFaqs = faqs && faqs.filter(faq => faq.title.toLowerCase().includes(search.toLowerCase()) || faq.type.toLowerCase().includes(search.toLowerCase())).slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet);
        if (idList.length ? idList.length === faqs.slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).length || idList.length === filteredFaqs.length : false) {
            const checkAllInput = document.getElementById("checkAllInput");
            if (!checkAllInput.checked)
                checkAllInput.checked = true;
        }
    }, [idList])

    useEffect(() => {
        setdata({ ...faqs, rows: sortedItems })
    }, [faqs])


    useEffect(() => {
        setSheet(0);
        setIdList([]);
        const checkAllInput = document.getElementById("checkAllInput");
        if (checkAllInput.checked)
            checkAllInput.checked = false;
        const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
        for (let checkBox of checkBoxes1) {
            if (checkBox.checked)
                checkBox.checked = false;
        }
        if (search === "") { setsearchflag(false) }
        else {
            setsearchflag(true)
        }
    }, [search])

    const fetchFaqs = async () => {
        const response = await axios.request({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            method: 'get',
            url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/get-help-faq`
        })
        setFaqs(response.data);
        callback();
    }

    const delList = (check, id) => {
        if (check) {
            // const ifsub = useSelector((state) => state.productDetails.listing.find((cat)));
            // setCategoryProductAssocClass('viewModal')
            setDelClass('viewModal')
            setDelId(id)
        }
    }


    const deleteFaqs = async (id) => {
        // alert(id)
        try {
            setLoading(true);
            setDelDisable(true);
            const response = await axios.request({
                data: { idList: id ? [id] : idList },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': Cookies.get('token')
                },
                method: 'post',
                url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/delete-faqs`
            })

            // alert(JSON.stringify(response))
            if (response.data.success) {
                if (id) {
                    toast.success(response.data.message)
                    setFaqs(faqs.filter(f => f._id !== id));
                    setDelClass('hideModal');
                }
                else {
                    toast.success(response.data.message)
                    const newFaqs = faqs.filter(p => idList.indexOf(p._id) === -1)
                    setFaqs(newFaqs);
                    setIdList([]);
                    setMultiDelClass('hideModal');
                    const checkAllInput = document.getElementById("checkAllInput");
                    if (checkAllInput.checked)
                        checkAllInput.checked = false;
                    const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
                    for (let checkBox of checkBoxes1) {
                        if (checkBox.checked)
                            checkBox.checked = false;
                    }
                }
            }
            callback()
        }
        catch (error) {
            toast.success(error)
            callback()
        }

    }

    var defaultSortBy = "createdAt";
    var defaultSortOrder = "desc";
    let [sortBy, setsortBy] = useState(defaultSortBy)             // default sort column
    let [sortOrder, setsortOrder] = useState(defaultSortOrder)    // default sort order

    const sortData = (sortBy, sortOrder, rows) => {
        var itemsToSort = JSON.parse(JSON.stringify(rows || faqs));
        var sortedItems = [];
        var compareFn = null;
        switch (sortBy) {
            case "createdAt":
                compareFn = (i, j) => {

                    if (i.createdAt < j.createdAt) {
                        return sortOrder === "desc" ? 1 : -1;
                    } else {
                        if (i.createdAt > j.createdAt) {
                            return sortOrder === "desc" ? -1 : 1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;
            case "title":
                compareFn = (i, j) => {

                    if (i.title < j.title) {
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (i.title > j.title) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;
            case "type":
                compareFn = (i, j) => {

                    if (i.type < j.type) {
                        return sortOrder === "asc" ? -1 : 1;
                    } else {
                        if (i.type > j.type) {
                            return sortOrder === "asc" ? 1 : -1;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                break;
            default:
                break;
        }
        console.log(`---->itemtosort${sortBy}`, itemsToSort)
        sortedItems = faqs ? itemsToSort.sort(compareFn) : '';
        console.log('---->sortItems', sortedItems)
        return sortedItems;
    }

    const requestSort = (pSortBy) => {

        var newsortBy = sortBy;
        var newsortOrder = sortOrder;

        console.log('-->newsortBy', newsortBy)
        console.log('-->newsortOrder', newsortOrder)
        console.log('-->pSortBy', pSortBy)

        return event => {
            if (pSortBy === newsortBy) {
                newsortOrder = newsortOrder === "asc" ? "desc" : "asc";
            } else {
                newsortBy = pSortBy;
                newsortOrder = "asc";
            }

            var sortedItems = sortData(newsortBy, newsortOrder);
            setdata({ ...data, rows: sortedItems })
            setsortBy(newsortBy)
            setsortOrder(newsortOrder)
        };
    }
    var sortedItems = sortData(defaultSortBy, defaultSortOrder, faqs);

    const [data, setdata] = useState({ ...faqs, rows: sortedItems })
    // 


    // setIsSubmitting(true);
    // const callback = () => setIsSubmitting(false);
    // { values: initialValues, callback }
    // console.log(data)
    return (
        <>
            <div className="dashContentHeader">
                <h5 className="dashHeading mb-0">Help/Faqs</h5>
            </div>
            {/* {console.log("Products", products)} */}
            <div className="dashboardCardRow">
                <div className="input-group mb-4 search-menu">

                    <Link to={'/post-new-faq'}>   <button className="border-0 sub-button mr-12"> Post New Faq </button></Link>
                </div>

                <div className="input-group mb-4 search-menu">
                    <input type="text" className="form-control" onChange={(e) => { setsearch(e.target.value) }} value={search} placeholder="Search faqs..." />
                    <div className="input-group-append">
                        <span className="input-group-text">
                            <i className="fa fa-search" aria-hidden="true"></i>
                        </span>
                    </div>
                    <button className="btn btn-custom-1" onClick={() => { setsearch("") }}>
                        <i class="fa fa-refresh" aria-hidden="true"></i> Reset</button>
                </div>
                <div className="listingTableRow">
                    <div className="listingTableHeader d-flex flex-wrap justify-content-between align-items-center pb-4 ">
                        <div className="custom-control custom-checkbox no-padding">
                            {/* <input type="checkbox" className="custom-control-input" id="checkAllInput" onChange={(event) => {

                                const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
                                if (event.target.checked) {
                                    for (let checkBox of checkBoxes1) {
                                        if (!checkBox.checked)
                                            checkBox.checked = true;
                                    }
                                    let tempArray = [];
                                    if (!searchflag) {
                                        faqs.slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).forEach(page => {
                                            tempArray.push(page._id);
                                        })
                                    }
                                    else {
                                        const filteredFaqs = faqs && faqs.filter(faq => faq.title.toLowerCase().includes(search.toLowerCase()) || faq.type.toLowerCase().includes(search.toLowerCase())).slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet);
                                        filteredFaqs.forEach(faq => {
                                            tempArray.push(faq._id);
                                        })
                                    }
                                    setIdList(tempArray);
                                }
                                else {
                                    for (let checkBox of checkBoxes1) {
                                        if (checkBox.checked)
                                            checkBox.checked = false;
                                    }
                                    setIdList([]);
                                }

                            }} /> */}
                            {/* <label className="custom-control-label" for="checkAllInput">Showing {searchflag ? (faqs && faqs.filter(faq => faq.title.toLowerCase().includes(search.toLowerCase()) || faq.type.toLowerCase().includes(search.toLowerCase())).slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).length) : (faqs && faqs.slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).length)} faqs</label> */}
                            <label className="right-label-checkbox">Showing {searchflag ? (faqs && faqs.filter(faq => faq.title.toLowerCase().includes(search.toLowerCase()) || faq.type.toLowerCase().includes(search.toLowerCase())).slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).length) : (faqs && faqs.slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).length)} faqs
                                <input type="checkbox" className="custom-control-input" id="checkAllInput" onChange={(event) => {

                                    const checkBoxes1 = document.getElementsByClassName("custom-control-input group1");
                                    if (event.target.checked) {
                                        for (let checkBox of checkBoxes1) {
                                            if (!checkBox.checked)
                                                checkBox.checked = true;
                                        }
                                        let tempArray = [];
                                        if (!searchflag) {
                                            faqs.slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).forEach(page => {
                                                tempArray.push(page._id);
                                            })
                                        }
                                        else {
                                            const filteredFaqs = faqs && faqs.filter(faq => faq.title.toLowerCase().includes(search.toLowerCase()) || faq.type.toLowerCase().includes(search.toLowerCase())).slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet);
                                            filteredFaqs.forEach(faq => {
                                                tempArray.push(faq._id);
                                            })
                                        }
                                        setIdList(tempArray);
                                    }
                                    else {
                                        for (let checkBox of checkBoxes1) {
                                            if (checkBox.checked)
                                                checkBox.checked = false;
                                        }
                                        setIdList([]);
                                    }

                                }} />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <button className="border-0 deleteButton mr-4" disabled={idList.length > 0 && getDelClass === "hideModal" && getMultiDelClass === "hideModal" ? false : true} style={idList.length === 0 ? { background: "grey" } : {}} onClick={() => setMultiDelClass('viewModal')}>
                                {!loading && <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.33398 3.66667V2.33333C3.33398 1.97971 3.47446 1.64057 3.72451 1.39052C3.97456 1.14048 4.3137 1 4.66732 1H7.33398C7.68761 1 8.02674 1.14048 8.27679 1.39052C8.52684 1.64057 8.66732 1.97971 8.66732 2.33333V3.66667M10.6673 3.66667V13C10.6673 13.3536 10.5268 13.6928 10.2768 13.9428C10.0267 14.1929 9.68761 14.3333 9.33398 14.3333H2.66732C2.3137 14.3333 1.97456 14.1929 1.72451 13.9428C1.47446 13.6928 1.33398 13.3536 1.33398 13V3.66667H10.6673Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.66602 7V11" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.33398 7V11" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>}
                                <span className="mt-1">Delete</span>
                            </button>
                        </div>
                    </div>
                    <div className="table-responsive">

                        <Table className="table customDashboardTable">
                            <TableHead>
                                <TableRow>
                                    <TableCell> <TableSortLabel active={sortBy === "title"} direction={sortOrder} onClick={requestSort("title")}>Faq Title </TableSortLabel> </TableCell>
                                    <TableCell> <TableSortLabel active={sortBy === "type"} direction={sortOrder} onClick={requestSort("type")}>Type</TableSortLabel> </TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell className="action-col"> Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {loading &&
                                    (
                                        <TableRow >
                                            <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                            <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                            <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                            <TableCell className="action-col"><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                                        </TableRow>
                                    )}

                                {!loading && data.rows && data.rows.filter(faq => faq.title.toLowerCase().includes(search.toLowerCase()) || faq.type.toLowerCase().includes(search.toLowerCase())).slice(sheet * rowsPerSheet, sheet * rowsPerSheet + rowsPerSheet).map((faq, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell>
                                                {/* <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input group1" id={`customCheck${index}`} onChange={(event) => {
                                                        if (event.target.checked) {
                                                            setIdList([...idList, faq._id]);
                                                        }
                                                        else {
                                                            setIdList(idList.filter(id => id !== faq._id));
                                                            const checkAllInput = document.getElementById("checkAllInput");
                                                            if (checkAllInput.checked)
                                                                checkAllInput.checked = false;
                                                        }
                                                    }} />
                                                    <label className="custom-control-label" for={`customCheck${index}`}>{faq.title}</label>
                                                    
                                                </div> */}
                                                <label className="right-label-checkbox orange">{faq.title}
                                                    <input type="checkbox" className="custom-control-input group1" id={`customCheck${index}`} onChange={(event) => {
                                                        if (event.target.checked) {
                                                            setIdList([...idList, faq._id]);
                                                        }
                                                        else {
                                                            setIdList(idList.filter(id => id !== faq._id));
                                                            const checkAllInput = document.getElementById("checkAllInput");
                                                            if (checkAllInput.checked)
                                                                checkAllInput.checked = false;
                                                        }
                                                    }} />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </TableCell>
                                            <TableCell> {faq.type}</TableCell>
                                            <TableCell dangerouslySetInnerHTML={{ __html: faq.desc.length >= 50 ? faq.desc.slice(0, 50) + "..." : faq.desc }}></TableCell>
                                            <TableCell className="action-col">
                                                {/* <div className="dropdown">
                                                    <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                                            <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                                            <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                                                        </svg>
                                                    </button>
                                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                                        <Link className="dropdown-item" to={`/post-new-faq/${faq._id}`}>Edit</Link>
                                                        <button className="dropdown-item" onClick={() => delList(true, faq._id)}>
                                                            Delete
                                                        </button>
                                                    </div>
                                                </div>  */}
                                                <ul className="action-list list-unstyled mb-0 d-flex align-items-center">
                                                    <li>
                                                        <Link to={`/post-new-faq/${faq._id}`} className="fa fa-pencil-square-o"></Link>
                                                    </li>
                                                    <li onClick={() => delList(true, faq._id)}>
                                                        <i className="fa fa-trash"></i>
                                                    </li>
                                                </ul>
                                            </TableCell>
                                        </TableRow>)
                                })}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]}
                            component="div"
                            count={data.rows ? data.rows.filter(faq => faq.title.toLowerCase().includes(search.toLowerCase()) || faq.type.toLowerCase().includes(search.toLowerCase())).length : 0}
                            rowsPerPage={rowsPerSheet}
                            page={sheet}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />

                    </div>


                    {/* <div className="tableArrowScrollar">
                        <ul className="d-flex align-items-center justify-content-end">
                            <li className="mr-4">
                                <button className="border-0 btn-link"><svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24 11H2" stroke="#C4C4C4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11 2L2 11L11 20" stroke="#C4C4C4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                </button>
                            </li>
                            <li>
                                <button className="border-0 btn-link">
                                    <svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 11H24" stroke="#FF7E06" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M15 2L24 11L15 20" stroke="#FF7E06" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </li>
                        </ul>
                    </div> */}
                </div>
            </div>

            <div id="delModal" className={`modal ${getDelClass}`} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header px-4">
                            <h5 className="modal-title">Delete List Item</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setDelClass('hideModal') }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body modal-padding">
                            <div className="text-center d-flex flex-column delete-modal">
                                <div>
                                    <h6 className="text-uppercase">Are you sure you want to delete this item ?</h6>
                                </div>
                                <div>
                                    <button className="btn btn-custom mr-2" disabled={delDisable} onClick={() => { setDelClass('hideModal') }}>No</button>
                                    <button className="btn btn-custom" disabled={delDisable} onClick={() => { deleteFaqs(getDelId); setdelLoading(true); setDelDisable(true) }} id="whiteBtn">
                                        {delLoading && <SyncLoader color={delcolor} loading={delLoading} css={override} size={11} />}
                                        {!delLoading && "Yes"}

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="multiDelModal" className={`modal ${getMultiDelClass}`} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header px-4">
                            <h5 className="modal-title">Delete Selected Items</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setMultiDelClass('hideModal') }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body modal-padding">
                            <div className="text-center d-flex flex-column delete-modal">
                                <div>
                                    <h6 className="text-uppercase">Are you sure you want to delete these selected items ?</h6>
                                </div>
                                <div>
                                    <button className="btn btn-custom mr-2" disabled={delDisable} onClick={() => { setMultiDelClass('hideModal') }}>No</button>
                                    <button className="btn btn-custom" disabled={delDisable} onClick={() => { deleteFaqs(); setdelLoading(true); setDelDisable(true) }} id="whiteBtn">
                                        {delLoading && <SyncLoader color={delcolor} loading={delLoading} css={override} size={11} />}
                                        {!delLoading && "Yes"}

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CMS_HelpFaq;